export type Storage<T> = {
  getItem: (key: T) => string | null;
  setItem: (key: T, value: string) => void;
  removeItem: (key: T) => void;
};

export type AuthTokens = {
  accessToken?: string;
  refreshToken?: string;
};

type AuthStoreKey = keyof AuthTokens;

export class TokenStore implements Storage<AuthStoreKey> {
  private readonly store: AuthTokens;

  constructor() {
    this.store = {
      accessToken: '',
      refreshToken: '',
    };
  }

  public getItem(key: AuthStoreKey): string | null {
    return this.store[key] || null;
  }

  public setItem(key: AuthStoreKey, value: string): void {
    this.store[key] = value;
  }

  public isSet() {
    return !!this.store.accessToken && !!this.store.refreshToken;
  }

  public removeItem(key: AuthStoreKey): void {
    delete this.store[key];
  }

  public clear(): void {
    this.store.accessToken = '';
    this.store.refreshToken = '';
  }
}

export const tokenStore = new TokenStore();
